// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bell-push-notification';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M14.156 6.62a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm-7.312 9.693a1.565 1.565 0 0 0 3.003 0M8.344 2.25V.562m5.642 8.408c.142 4.318 1.108 5.093 1.108 5.093h-13.5s1.125-1.437 1.125-6.188a5.63 5.63 0 0 1 7.293-5.374'
  />
);

export const viewBox = '0 0 18 18';
